import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { QuestiongameListLayer } from '../components/questiongame/QuestiongameListLayer'

export const QuestiongameListPage = () => {
  return (
    <MasterLayout>
        <QuestiongameListLayer/>
    </MasterLayout>
  )
}
